import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EnvironmentByOrganisationIdAndIdQueryVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  organisationId: Types.Scalars['String']['input'];
}>;


export type EnvironmentByOrganisationIdAndIdQuery = { __typename?: 'Query', environmentByOrganisationIdAndId?: { __typename?: 'Environment', id: string, actionConfiguration: unknown } | null };

export type SaveEnvironmentActionConfigurationMutationVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  actionConfiguration: Types.Scalars['JSON']['input'];
}>;


export type SaveEnvironmentActionConfigurationMutation = { __typename?: 'Mutation', updateEnvironment?: { __typename?: 'UpdateEnvironmentPayload', environment?: { __typename?: 'Environment', id: string, actionConfiguration: unknown } | null } | null };


export const EnvironmentByOrganisationIdAndIdDocument = gql`
    query EnvironmentByOrganisationIdAndId($environmentId: String!, $organisationId: String!) {
  environmentByOrganisationIdAndId(
    id: $environmentId
    organisationId: $organisationId
  ) {
    id
    actionConfiguration
  }
}
    `;

/**
 * __useEnvironmentByOrganisationIdAndIdQuery__
 *
 * To run a query within a React component, call `useEnvironmentByOrganisationIdAndIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentByOrganisationIdAndIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentByOrganisationIdAndIdQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useEnvironmentByOrganisationIdAndIdQuery(baseOptions: Apollo.QueryHookOptions<EnvironmentByOrganisationIdAndIdQuery, EnvironmentByOrganisationIdAndIdQueryVariables> & ({ variables: EnvironmentByOrganisationIdAndIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentByOrganisationIdAndIdQuery, EnvironmentByOrganisationIdAndIdQueryVariables>(EnvironmentByOrganisationIdAndIdDocument, options);
      }
export function useEnvironmentByOrganisationIdAndIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentByOrganisationIdAndIdQuery, EnvironmentByOrganisationIdAndIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentByOrganisationIdAndIdQuery, EnvironmentByOrganisationIdAndIdQueryVariables>(EnvironmentByOrganisationIdAndIdDocument, options);
        }
export function useEnvironmentByOrganisationIdAndIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EnvironmentByOrganisationIdAndIdQuery, EnvironmentByOrganisationIdAndIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnvironmentByOrganisationIdAndIdQuery, EnvironmentByOrganisationIdAndIdQueryVariables>(EnvironmentByOrganisationIdAndIdDocument, options);
        }
export type EnvironmentByOrganisationIdAndIdQueryHookResult = ReturnType<typeof useEnvironmentByOrganisationIdAndIdQuery>;
export type EnvironmentByOrganisationIdAndIdLazyQueryHookResult = ReturnType<typeof useEnvironmentByOrganisationIdAndIdLazyQuery>;
export type EnvironmentByOrganisationIdAndIdSuspenseQueryHookResult = ReturnType<typeof useEnvironmentByOrganisationIdAndIdSuspenseQuery>;
export type EnvironmentByOrganisationIdAndIdQueryResult = Apollo.QueryResult<EnvironmentByOrganisationIdAndIdQuery, EnvironmentByOrganisationIdAndIdQueryVariables>;
export const SaveEnvironmentActionConfigurationDocument = gql`
    mutation SaveEnvironmentActionConfiguration($environmentId: String!, $actionConfiguration: JSON!) {
  updateEnvironment(
    input: {id: $environmentId, patch: {actionConfiguration: $actionConfiguration}}
  ) {
    environment {
      id
      actionConfiguration
    }
  }
}
    `;

/**
 * __useSaveEnvironmentActionConfigurationMutation__
 *
 * To run a mutation, you first call `useSaveEnvironmentActionConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEnvironmentActionConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEnvironmentActionConfigurationMutation, { data, loading, error }] = useSaveEnvironmentActionConfigurationMutation({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      actionConfiguration: // value for 'actionConfiguration'
 *   },
 * });
 */
export function useSaveEnvironmentActionConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SaveEnvironmentActionConfigurationMutation, SaveEnvironmentActionConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEnvironmentActionConfigurationMutation, SaveEnvironmentActionConfigurationMutationVariables>(SaveEnvironmentActionConfigurationDocument, options);
      }
export type SaveEnvironmentActionConfigurationMutationHookResult = ReturnType<typeof useSaveEnvironmentActionConfigurationMutation>;
export type SaveEnvironmentActionConfigurationMutationResult = Apollo.MutationResult<SaveEnvironmentActionConfigurationMutation>;
export type SaveEnvironmentActionConfigurationMutationOptions = Apollo.BaseMutationOptions<SaveEnvironmentActionConfigurationMutation, SaveEnvironmentActionConfigurationMutationVariables>;